export enum TextConversationStatus {
    Active = 0,
    Inactive = 1
}